module.exports = __webpack_public_path__ + "img/video_thumb_02.873fdb97.png";